import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';

const formatMoeda = (val) =>
  val != null
    ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : '—';

const formatData = (val) => {
  if (!val) return '—';
  const d = new Date(val);
  if (isNaN(d.getTime())) return val;
  return d.toLocaleDateString('pt-BR');
};

const Campo = ({ label, valor }) => (
  <Col md={3} className="mb-2">
    <Form.Group>
      <Form.Label className="font-weight-bold small mb-0">{label}</Form.Label>
      <Form.Control
        plaintext
        readOnly
        value={valor}
        className="py-0"
      />
    </Form.Group>
  </Col>
);

const PainelCalculo = ({ calculo }) => {
  if (!calculo) return null;

  return (
    <Card className="mb-3 border-info">
      <Card.Header as="h6" className="bg-info text-white">
        Cálculo IPTU do Empreendimento
      </Card.Header>
      <Card.Body>
        <Row>
          <Campo label="Valor Geral IPTU" valor={formatMoeda(calculo.valor_geral_iptu)} />
          <Campo label="Data Lançamento" valor={formatData(calculo.dt_lanc)} />
          <Campo label="Área Total" valor={calculo.area_total != null ? `${calculo.area_total.toFixed(2)} m²` : '—'} />
          <Campo label="Valor Empresa IPTU" valor={formatMoeda(calculo.valor_empresa_iptu)} />
          <Campo label="Valor/m² IPTU" valor={formatMoeda(calculo.valor_m2_iptu)} />
          <Campo label="Meses Empresa" valor={calculo.meses_emp != null ? String(calculo.meses_emp) : '—'} />
          <Campo label="Valor a Agrupar" valor={formatMoeda(calculo.valor_agrupar)} />
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PainelCalculo;
